import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function ArtikelManagePage() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit] = useState(10);

  const [categories, setCategories] = useState([]);
  const [pricelists, setPricelists] = useState([]);

  const [form, setForm] = useState({
    id: null,
    categoryId: '',
    title: '',
    abstrak: '',
    tahun_publikasi: '',
    author: '',
    json_akses_paket: [],
    file: null,
  });

  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(false);

  const fetchData = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/datatable/articles`, {
      params: { start: page * limit, length: limit, search },
      withCredentials: true,
    });
    setData(res.data.data);
    setTotal(res.data.recordsFiltered);
  };

  const fetchSupporting = async () => {
    const [catRes, priceRes] = await Promise.all([
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/datatable/category-article`, { withCredentials: true }),
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/datatable/pricelist`, { withCredentials: true, params: { start: 0, length: 1000 } }),
    ]);
    setCategories(catRes.data.data);

   const newPricelists = [
    { id: 0, code: 'FREE', name: 'FREE', price: 0, session_create_max: 5, chat_attempt_max: 5, max_ai_token: 1000 },
    ...priceRes.data.data
    ];

    setPricelists(newPricelists);
  };

  useEffect(() => {
    fetchData();
    fetchSupporting();
  }, [page, search]);

  const resetForm = () => {
    setForm({
      id: null,
      categoryId: '',
      title: '',
      abstrak: '',
      tahun_publikasi: '',
      author: '',
      json_akses_paket: [],
      file: null,
    });
    setEditing(false);
  };

  const openCreateModal = () => {
    resetForm();
    setShowModal(true);
  };

  const editForm = async (item) => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/articles/${item.id}`, { withCredentials: true });
    const parsed = {
      ...res.data,
      json_akses_paket: JSON.parse(res.data.json_akses_paket || '[]'),
      file: null,
    };
    setForm(parsed);
    setEditing(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(form).forEach(([key, val]) => {
      if (key === 'json_akses_paket') {
        formData.append(key, JSON.stringify(val));
      } else if (key === 'file' && val) {
        formData.append('file', val);
      } else {
        formData.append(key, val);
      }
    });

    try {
      if (editing) {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/admin/articles/${form.id}`, formData, {
          withCredentials: true,
        });
        Swal.fire('Berhasil', 'Data berhasil diperbarui', 'success');
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/articles`, formData, {
          withCredentials: true,
        });
        Swal.fire('Berhasil', 'Data berhasil disimpan', 'success');
      }
      setShowModal(false);
      fetchData();
      resetForm();
    } catch (err) {
      Swal.fire('Oops!', err.response?.data?.message || 'Gagal simpan.', 'error');
    }
  };

  const deleteItem = async (id) => {
    const result = await Swal.fire({
      title: 'Yakin ingin menghapus data ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, hapus!',
    });

    if (result.isConfirmed) {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/admin/articles/${id}`, { withCredentials: true });
      Swal.fire('Berhasil', 'Artikel dihapus.', 'success');
      fetchData();
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox' && name === 'json_akses_paket') {
      setForm((prev) => {
        const updated = checked
          ? [...prev.json_akses_paket, value]
          : prev.json_akses_paket.filter((v) => v !== value);
        return { ...prev, json_akses_paket: updated };
      });
    } else if (type === 'file') {
      setForm((prev) => ({ ...prev, file: e.target.files[0] }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  return (
    <div className="container-fluid px-0">
      <h3>Manage Artikel</h3>
      <div className="row mb-2">
        <div className="col">
          <input className="form-control" placeholder="Cari Judul / Author..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <div className="col-auto">
          <button className="btn btn-dark" onClick={openCreateModal}><i className="fa fa-plus"></i> Tambah Data Baru</button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th className='bg-light'>Judul</th>
              <th className='bg-light' width="15%">Author</th>
              <th className='bg-light' width="15%">Kategori</th>
              <th className='bg-light text-center' width="5%">Tahun Publikasi</th>
              <th className='bg-light text-center' width="10%">File</th>
              <th className='bg-light text-center' width="10%">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>{item.title}</td>
                <td>{item.author}</td>
                <td>{item.category}</td>
                <td className='text-center'>{item.tahun_publikasi}</td>
                <td className='text-center'>
                    <a href={`${process.env.REACT_APP_API_BASE_URL}/admin/preview/article/${item.file}`} className="btn btn-sm btn-outline-dark" target="_blank" rel="noreferrer"><i className="fa fa-eye"></i> Preview</a>
                </td>
                <td className='text-center'>
                  <button className="btn btn-sm btn-outline-dark me-1" onClick={() => editForm(item)}><i className="fa fa-edit"></i></button>
                  <button className="btn btn-sm btn-outline-dark" onClick={() => deleteItem(item.id)}><i className="fa fa-trash"></i></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between">
        <small>Total: {total}</small>
        <div>
          <button className="btn btn-sm btn-secondary me-2" disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
          <button className="btn btn-sm btn-secondary" disabled={(page + 1) * limit >= total} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      </div>

      {showModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{editing ? 'Edit' : 'Tambah'} Artikel</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body row g-2">

                  <div className="col-md-6">
                    <label>Kategori</label>
                    <select className="form-control" name="categoryId" value={form.categoryId} onChange={handleChange} required>
                      <option value="">--Pilih--</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label>Tahun Publikasi</label>
                    <input type="number" min="1900" max="2100" className="form-control" name="tahun_publikasi" value={form.tahun_publikasi} onChange={handleChange} required />
                  </div>
                  <div className="col-md-6">
                    <label>Judul</label>
                    <input type="text" className="form-control" name="title" value={form.title} onChange={handleChange} required />
                  </div>
                  <div className="col-md-6">
                    <label>Author</label>
                    <input type="text" className="form-control" name="author" value={form.author} onChange={handleChange} required />
                  </div>
                  <div className="col-md-12">
                    <label>Abstrak</label>
                    <textarea className="form-control" name="abstrak" value={form.abstrak} onChange={handleChange} required></textarea>
                  </div>

                  <div className="col-md-12">
                    <label>File PDF {editing && <small>(Kosongkan jika tidak diubah)</small>}</label>
                    <input type="file" accept="application/pdf" className="form-control" name="file" onChange={handleChange} />
                  </div>

                  <div className="col-md-12">
                    <label>Akses Paket</label>
                    <div className="d-flex flex-wrap">
                      {pricelists.map((p) => (
                        <div key={p.id} className="form-check me-3">
                          <input className="form-check-input" type="checkbox" name="json_akses_paket" id={'cb'+p.id} value={p.id}
                            checked={form.json_akses_paket.includes(String(p.id))} onChange={handleChange} />
                          <label className="form-check-label" for={'cb'+p.id}>{p.name}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-dark">{editing ? 'Update' : 'Simpan'}</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Tutup</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ArtikelManagePage;